export const CHECKABLE_FIELDS = {
  EXPIRY_DATE: 'EXPIRY_DATE',
  CREDIT: 'CREDIT',
  WEBSITE_URL: 'WEBSITE_URL',
  EMAIL_TEMPLATE_ID: 'EMAIL_TEMPLATE_ID',
};
